import Project from "./Project.Container";

export default Project;